import React from 'react'

const TooltipSpan = ({content, tooltip}) => (
  <span data-tooltip-id='tooltip' data-tooltip-content={tooltip} data-tooltip-place='bottom'>
    {content}
  </span>
)

export {TooltipSpan}
